import { render, staticRenderFns } from "./sidebarMenu.vue?vue&type=template&id=0d52c408&scoped=true&"
import script from "./sidebarMenu.vue?vue&type=script&lang=js&"
export * from "./sidebarMenu.vue?vue&type=script&lang=js&"
import style0 from "./sidebarMenu.vue?vue&type=style&index=0&lang=less&"
import style1 from "./sidebarMenu.vue?vue&type=style&index=1&id=0d52c408&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d52c408",
  null
  
)

export default component.exports